import React from "react";
import { WorkesSectionStyle } from "./style";

import stepOne from "../../images/workesSection/stepOne.png";
import stepTwo from "../../images/workesSection/stepTwo.png";
import stepThree from "../../images/workesSection/stepThree.png";
import PlayStoreQr from "../qrCode/playStoreQr";
import AppStoreQr from "../qrCode/appStoreQr";

const WorkesSection = () => {
  return (
    <WorkesSectionStyle>
      {/* How-It-Workes-Section-Start */}
      <section className="row_am how_it_works" id="how_it_work">
        {/* container start */}
        <div className="container">
          <div className="how_it_inner">
            <div
              className="section_title"
              data-aos="fade-up"
              data-aos-duration={1500}
              data-aos-delay={300}
            >
              {/* h2 */}
              <h2>
                <span>How it works</span> - 3 easy steps
              </h2>
              {/* p */}
              <p>
                Download the app, create a free account, and start enjoying a
                seamless experience.
              </p>
            </div>
            <div className="step_block">
              {/* UL */}
              <ul>
                {/* step */}
                <li>
                  <div
                    className="step_text"
                    // data-aos="fade-right"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                  >
                    <h4>Download app</h4>
                    <p>Download App either for iOS or Android</p>
                    <div className="app_icon appIcons">
                      <div className="playStore-main">
                       
                          <a href="#" className="icon-apps">
                            <i className="icofont-brand-android-robot " />
                          </a>
                        <div className="qr-codes">
                          <PlayStoreQr />
                        </div>
                      </div>
                      <div className="AppStoreStore-main">
                        
                          <a href="#" className="icon-apps">
                            <i className="icofont-brand-apple" />
                          </a>
                        
                        <div className="qr-codes">
                          <a href="#">
                            <AppStoreQr />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="step_number">
                    <h3>01</h3>
                  </div>
                  <div
                    className="step_img"
                    // data-aos="fade-left"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                  >
                    <img src={stepOne} alt="image" />
                  </div>
                </li>
                {/* step */}
                <li>
                  <div
                    className="step_text"
                    // data-aos="fade-left"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                  >
                    <h4>Create account</h4>
                    {/* <span>14 days free trial</span> */}
                    <p>
                      Sign up free for App account. One account for all devices.
                    </p>
                  </div>
                  <div className="step_number">
                    <h3>02</h3>
                  </div>
                  <div
                    className="step_img"
                    // data-aos="fade-right"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                  >
                    <img src={stepTwo} alt="image" />
                  </div>
                </li>
                {/* step */}
                <li>
                  <div
                    className="step_text"
                    // data-aos="fade-right"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                  >
                    <h4>It’s done, enjoy the app</h4>
                    <span>
                      Have any questions check our{" "}
                      <a href="#" className="text-clr">
                        FAQs
                      </a>
                    </span>
                    <p>
                      Get most amazing app experience,Explore and share the app
                    </p>
                  </div>
                  <div className="step_number">
                    <h3>03</h3>
                  </div>
                  <div
                    className="step_img"
                    // data-aos="fade-left"
                    data-aos="fade-up"
                    data-aos-duration={1500}
                  >
                    <img src={stepThree} alt="image" />
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* container end */}
      </section>
      {/* How-It-Workes-Section-end */}
    </WorkesSectionStyle>
  );
};

export default WorkesSection;
